import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { MerchantPaymentRequestsListContent } from './MerchantPaymentRequestsListContent';

export default function PaymentRequestsPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <MerchantPaymentRequestsListContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
